export default {
  namespaced: true,

  state: {
    docMenuListData: [],
    articleData: null,
    articleList: {}
  },
  getters: {
    docMenuList(state) {
      let data = state.docMenuListData[0] || {};
      return (
        (data.children &&
          data.children.map(item => {
            if (["faq", "notice"].includes(data.menuParentCode)) {
              return {
                ...item,
                routeName: data.menuParentCode
              };
            } else {
              return { ...item, routeName: data.menuParentCode };
            }
          })) ||
        []
      );
    }
  },
  actions: {
    async getDocMenuList( //获取文章菜单
      { dispatch, commit, getters, rootGetters, state, rootState },
      data = {}
    ) {
      let res = await rootState.axios.post(
        "/server/portal/menu/articleList",
        data
      );
      commit("setDocMenuListData", res.data.data);
    },
    async getArticle( //文章详情
      { dispatch, commit, getters, rootGetters, state, rootState },
      data = {}
    ) {
      let res = await rootState.axios.post("/server/portal/menu/article", data);
      //  commit("setArticleData", res.data.data);
      commit("setArticleList", res.data.data);
    },
    async getArticleList( //分页查询文章列表
      { dispatch, commit, getters, rootGetters, state, rootState },
      data = {}
    ) {
      let res = await rootState.axios.post(
        "/server/portal/menu/queryMenu",
        data
      );
      commit("setArticleList", res.data.data);
    }
  },

  mutations: {
    setDocMenuListData(state, data) {
      state.docMenuListData = data;
    },
    setArticleData(state, data) {
      state.articleData = data;
    },
    setArticleList(state, data) {
      state.articleList = data;
    }
  }
};
